module.exports = __webpack_public_path__ + "img/opcion-4.bfaae232.png";